// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"success-list_wrapper__uWU1H","borderWrap":"success-list_borderWrap__Bzhof","grid":"success-list_grid__Ao5rM"};